/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Line_Up_TitleInputs */



/**
* | output |
* | --- |
* | "Move Up One Line" |
*
* @param {Position_Line_Up_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_line_up_title = /** @type {((inputs?: Position_Line_Up_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Line_Up_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Monter d'Une Ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Zeile nach oben rücken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spostati di una riga in su")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместитесь на одну строку вверх")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subir una línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向上移动一行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1行上に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक पंक्ति ऊपर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Subir uma linha")
	return /** @type {LocalizedString} */ ("Move Up One Line")
});